/*

? First, let's import the interface that will describe the shape of our payment transaction object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the payment transaction object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const payment_transaction: StateInterface["payment_transaction"] = {
	_id: "",
	created_at: "",
	transaction_data: {
		_id_copy: "",
		currency: "",
		sub_total: 0,
		tax_details: {
			tax_name: "",
			tax_percentage: 0,
			tax_amount: 0,
		},
		grand_total: 0,
		transaction_direction: "",
		transaction_category: "",
		transaction_purpose: "",
		transaction_status: "",
		billing_info_snapshot: {
			customer_legal_name: "",
			contact_email: "",
			billing_phone: {
				country_code: "",
				phone_number: "",
			},
			address_line1: "",
			address_line2: "",
			city: "",
			state_region: "",
			postal_code: "",
			country: "",
			tax_name: "",
			tax_id_number: "",
		},
		payment_provider: "",
		payment_provider_metadata: {
			razorpay: {
				order_details: {
					order_id: "",
					order_status: "",
					order_amount: 0,
					order_amount_paid: 0,
					order_amount_due: 0,
					order_currency: "",
					order_payment_attempts: 0,
					order_receipt: "",
				},
				order_notes: {
					redirect_url: "",
				},
				payment_details: {
					razorpay_payment_id: "",
					razorpay_order_id: "",
					razorpay_signature: "",
					reason_for_decline: "",
					created_at: "",
				},
			},
		},
		transacted_by: {
			_id: "",
			is_business_profile: false,
			user_id: "",
			business_profile_id: "",
			team_role: "",
		},
		transaction_timeout_at: "",
	},
};
